<script>
import metaInfo from '@/modules/mixins/metaInfo'
import Vue from 'vue'
import { Sap } from '@/api'
import DataRow from '@/components/atoms/DataRow'

const sap = Vue.observable(new Sap())

export default {
    name: 'Integrations',
    components: { DataRow },
    mixins: [metaInfo],
    computed: {
        sap: () => sap,
        pageTitle() {
            return this.$t('profile.pages.integrations')
        },
    },
    mounted() {
        this.sap.getStatus()
    },
    methods: {
        connect() {
            this.sap.getRedirectUrl().then((res) => {
                window.location.href = res
            })
        },
        disconnect() {
            this.sap.disconnect()
        },
    },
}
</script>

<template lang="pug">
.profile-allowances
    h2 {{ $t('profile.integrations') }}
    .card
        .card-body
            data-row(:label="$t('profile.sap_concur')")
                button.btn.btn-secondary.btn-xs(v-if="sap.status" @click="disconnect") {{$t('profile.disconnect')}}
                button.btn.btn-primary.btn-xs(@click="connect" v-else) {{$t('profile.connect')}}
            p.body-sm.text-73.mt-5 {{$t('profile.support')}}
</template>
